export default Object.freeze({
  TEXT: 'text',
  TEXTAREA: 'textarea',
  CHOICE: 'choice',
  TEXT_CHOICE: 'text_choice',
});
